import { Copy, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useRx } from "@/context/AuthContext";
import { actionTone, fmt, scoreColor, toneClasses } from "@/lib/format";

export default function ShareCardDialog({ item, onClose }) {
  const { me } = useRx();
  if (!item) return null;
  const link = `${window.location.origin}/?ref=${me?.referral_code || ""}`;
  const lv = item.levels.map((l) => `${l.k}: ${typeof l.v === "number" ? fmt(l.v) : l.v}`).join(" | ");
  const text = `Robo-X Signal\n${item.action} ${item.instrument}\nStrength Score: ${item.score.toFixed(0)}/100\n${lv}\n\nJoin Robo-X with my code ${me?.referral_code || ""}: ${link}\n(Educational, not investment advice)`;
  const tone = actionTone(item.action);
  return (
    <Dialog open={!!item} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#11151C] border-white/10 max-w-md" data-testid="share-dialog">
        <DialogHeader><DialogTitle className="font-display">Share signal card</DialogTitle></DialogHeader>
        <div className="relative overflow-hidden rounded-2xl p-5 border border-white/10 bg-[#050505] rx-grid-bg" data-testid="share-card-preview">
          <div className="absolute -right-10 -top-10 h-40 w-40 rounded-full blur-3xl" style={{ background: `${scoreColor(item.score)}33` }} />
          <div className="flex items-center justify-between">
            <span className="font-display font-black tracking-tight">ROBO<span className="text-[#00FF66]">-X</span></span>
            <span className="font-data text-[10px] text-gray-500">{new Date().toLocaleString("en-IN")}</span>
          </div>
          <div className="mt-4 flex items-end justify-between">
            <div>
              <span className={`font-data text-xs font-bold px-2 py-1 rounded-md border ${toneClasses[tone]}`}>{item.action}</span>
              <div className="font-display text-xl font-bold mt-2">{item.instrument}</div>
            </div>
            <div className="text-right">
              <div className="font-data text-4xl font-bold" style={{ color: scoreColor(item.score) }}>{item.score.toFixed(0)}</div>
              <div className="rx-label">Strength</div>
            </div>
          </div>
          <div className="mt-4 grid grid-cols-2 gap-2">
            {item.levels.map((l) => (
              <div key={l.k} className="rounded-lg bg-white/5 p-2">
                <div className="text-[10px] uppercase tracking-wider text-gray-500">{l.k}</div>
                <div className="font-data text-sm">{typeof l.v === "number" ? fmt(l.v) : l.v}</div>
              </div>
            ))}
          </div>
          <div className="mt-4 text-[11px] text-gray-500">Code <span className="font-data text-[#00FF66]">{me?.referral_code}</span> · Simulated feed · Not investment advice</div>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <a href={`https://wa.me/?text=${encodeURIComponent(text)}`} target="_blank" rel="noreferrer" data-testid="share-whatsapp-btn"
            className="flex items-center justify-center gap-2 rounded-full bg-[#25D366] text-black font-bold py-2.5 hover:brightness-110 transition-[filter]">
            <MessageCircle size={16} /> WhatsApp
          </a>
          <button data-testid="share-copy-btn" onClick={() => { navigator.clipboard?.writeText(text); toast.success("Signal copied"); }}
            className="flex items-center justify-center gap-2 rounded-full border border-white/15 py-2.5 hover:bg-white/5 transition-colors">
            <Copy size={16} /> Copy text
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
